/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import firebaseApp from './firebase'
import Firebase from 'firebase'
import VueFire from 'vuefire'
import VueCookie from 'vue-cookie'
import Vuex from 'vuex'

Vue.use(VueFire)
Vue.use(Vuex)
Vue.use(VueCookie)

firebase.auth().onAuthStateChanged(function (user) {
  new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
  })
})



// WEBPACK FOOTER //
// ./src/main.js